// Import modules...
import Vue from 'vue'
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue'
import PortalVue from 'portal-vue'

import { InertiaProgress } from '@inertiajs/progress'

import VueTailwind from 'vue-tailwind'
import TTable from 'vue-tailwind/dist/t-table'

import '@voerro/vue-tagsinput/dist/style.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPencilAlt, faTrash, faTimes, faPlus, faRetweet, faEye, faBell } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import AppLayout from '@/Layouts/App'
import FormInput from '@/Components/Inputs/FormInput'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

Sentry.init({
  Vue,
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
})

library.add(faPencilAlt)
library.add(faTrash)
library.add(faTimes)
library.add(faPlus)
library.add(faRetweet)
library.add(faEye)
library.add(faBell)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('app-layout', AppLayout)
Vue.component('form-input', FormInput)
Vue.component('manager', () => import(/* webpackPrefetch: true */ '@/Components/Management/Manager'))
Vue.component('reorder', () => import(/* webpackPrefetch: true */ '@/Components/Management/Reorder'))

require('./bootstrap')
InertiaProgress.init()
const components = {
  TTable,
}

Vue.use(VueTailwind, components)

Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaPlugin)
Vue.use(PortalVue)

const app = document.getElementById('app')

new Vue({
  render: (h) =>
    h(InertiaApp, {
      props: {
        initialPage: JSON.parse(app.dataset.page),
        resolveComponent: (name) => import(/* webpackPrefetch: true */ `./Pages/${name}`).then(module => module.default),
      },
    }),
}).$mount(app)
